<template>
<div>
<div class="col-md-12">
    <div class="row" style="margin-top:20px">
        <div class="col-md-6" >
            <h3 class="page-header">
            <i class="fa fa fa-user animated bounceInDown show-info"></i>
            Employee Report
            </h3>
        </div>
        <div class="col-md-6 ">
            <div class="row">
                <div class="col-md-10" >
                    <div class="row" style="padding-top:18px;justify-content:flex-end;" v-if="viewno==1">
                        <div  class="col-md-2" style="margin-right:25px;">             
                            <button @click="refresh()" class="btn btn-primary" ><i class="fa fa-refresh"></i>  Refresh</button>
                        </div>
                    </div>
                    <div class="row" style="padding-top:18px;justify-content:flex-end;" v-if="viewno==3">
                        <div  class="col-md-2" style="margin-right:25px;">             
                            <button @click="back()" class="btn btn-primary" >Back</button>
                        </div>
                    </div>
                </div>
            </div>
         </div>
    </div>
</div>
    
    <template v-if="viewno==1">
    <div class="col-md-12">
      <div class="row">
            <div class="col-md-6">
                <div class="info-box  bg-success-dark  text-white">
                    <div class="info-icon bg-purple">
                        <i class="fa fa fa-user fa-2x"></i>
                    </div>
                    <div class="info-details">
                        <h4>Total Active Employee: 
                            <span class="badge bg-danger" style="font-size:medium;">
                                {{ this.activecount}}
                            </span>
                        </h4>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="info-box  bg-danger-dark  text-white">
                    <div class="info-icon bg-purple">
                        <i class="fa fa fa-user fa-2x"></i>
                    </div>
                    <div class="info-details">
                        <h4>Total Employee:  
                            <span class="badge bg-success" style="font-size:medium;">
                                {{this.totalemp}}
                            </span>
                        </h4>
                    </div>
                </div>
            </div>
      </div>
    </div>
    <div class="row">
        <div class="col-md-10 pt-0 pb-10">
            <div class="form-horizontal">
                <div class="form-group">
                <label class="col-lg-4 co-md-3 control-label "> <b> Search Records</b></label>
                    <div class="col-lg-8 col-md-9 pull-right ">
                    <input id="myInput" onkeyup="searchTable()" type="text" class="form-control form-cascade-control input-small">
                    </div>
                </div>
            </div>
        </div>
    </div>
   
    <div class="col-md-12 mt-20">
        <div class="row">
            <div class="col-md-2">
                <strong>Show Rec.</strong>
            </div>
            <div class="col-md-2">
                <select class="form-control col-mb-1" v-model="noofrec" id="rec">
                    <option value=10>10</option>
                    <option value=25>25</option>
                    <option value=50>50</option>
                    <option value=100>100</option>
                </select>
            </div>
        </div>
    </div>
    <div class="col-md-12">
        <div class="panel">
            <div class="panel-body">
                <table class="table table-bordered table-hover table-striped display" id="tblmanual">
                    <thead class="table-font">
                        <tr>
                            <th class="visible-lg">#</th>
                            <th>Vsdigi ID</th>
                            <th class="visible-lg">Name</th>
                            <th>Email </th>
                            <th>User ID </th>
                            <th class="visible-lg">Mobile No</th>
                            <th class="visible-lg">Address</th>
                            <th class="visible-lg">Created By</th>
                            <th class="visible-lg">Follow Up</th>
                            <th v-if="loginusercheck('17')">Can collect cash</th>
                            <th v-if="loginusercheck('17')">Edit</th>
                            <th v-if="loginusercheck('15')">Action</th>
                        </tr>
                    </thead>
                    <tbody class="table-font">
                        <tr v-for="(item,index) in employees" v-bind:key="item.id">
                            <td>{{index+1 }}</td>
                            <td>{{item.generatedid}}</td>
                            <td>{{item.name}}
                                <br>
                                <small v-if="(item.schedule_duration_from > 0 || item.schedule_duration_to > 0)">
                                    <b>Schedule :</b>
                                    {{ item.schedule_duration_from || 0 }} - {{ item.schedule_duration_to || item.schedule_duration_from || 0 }} days
                                </small>
                            </td>
                            <td>{{item.email}}</td>
                            <td>{{item.username}}</td>
                            <td><display-mobiles :mobiles="item.mobiles"></display-mobiles></td>
                            <td><display-first-address :addresses="item.addressess"></display-first-address></td>
                            <td><div v-if="item.enteredby!=null">{{item.enteredby.name}}</div></td>
                            <td><a href="#" @click="getfollowedaccounts(item)">{{ getfollow(item)}}</a></td>
                            <td v-if="loginusercheck('17')"><input type="checkbox" :checked="Number(item.can_collect_cash) === 1" :disabled="cashCollectorSavingIds.includes(item.id)" @change="saveCashCollector(item, $event)" :aria-label="'Allow ' + item.name + ' to collect cash'" /></td>
                            <td v-if="loginusercheck('17')">
                                <button type="button" class="btn btn-success btn-xs" @click="edit(item)">
                                    <i class="fa fa-edit"></i> Edit
                                </button>
                                <button type="button" class="btn btn-primary btn-xs" @click="$refs.loanTransfer.open(item)">Transfer accounts</button>
                            </td>
                            <td v-if="loginusercheck('15')">
                                <button type="button"  @click="active(item)"  class="btn btn-xs">
                                    <div  class="bg-sheme btn-xs" v-if="item.active==0">Deactive</div>
                                    <div  class="grd-bg-ff5722 btn-xs" v-else><i class="fa fa-check"></i>Activate</div>
                                </button>
                                <button type="button" class="btn btn-success btn-xs" @click="openScheduleModal(item)">
                                    Schedule
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="col-md-12" style="margin-top: 20px">
                    <nav aria-label="Page navigation example" style="text-align: right !important">   
                    <paginate
                        style="margin: 0px !important; float: right"
                        :page-count="noofpages"
                        :click-handler="clickCallback"
                        :prev-text="'&laquo;'"
                        :next-text="'&raquo;'"
                        :container-class="'pagination'">
                    </paginate>
                    </nav>
                </div>
            </div>
        </div>
    </div>
    </template>
    <employee-form v-if="viewno==2"></employee-form>
    <loan-account-followed v-if="viewno==3" :followedid="followedid"></loan-account-followed>
    <modal name="schedule-modal" :width="520" :height="320" draggable=".window-header">
        <div class="col-md-12 pb-10 text-center">
            <h3 class="window-header" style="border-bottom: 1px solid green;">Employee Schedule</h3>
        </div>
        <div class="col-md-12">
            <label>
                Schedule duration from / to in days
                <span v-if="scheduleEmployee">for {{ scheduleEmployee.name }}</span>
            </label>
            <div class="row">
                <div class="col-md-6">
                    <input
                        v-model.number="scheduleDurationFrom"
                        type="number"
                        min="0"
                        step="1"
                        class="form-control"
                        placeholder="From days"
                        @keyup.enter="saveSchedule"
                    >
                </div>
                <div class="col-md-6">
                    <input
                        v-model.number="scheduleDurationTo"
                        type="number"
                        min="0"
                        step="1"
                        class="form-control"
                        placeholder="To days"
                        @keyup.enter="saveSchedule"
                    >
                </div>
            </div>
        </div>
        <div class="col-md-12 pt-20 pb-20 flex-between-row">
            <button type="button" class="btn bg-success text-white btn-sm" :disabled="savingSchedule" @click="saveSchedule">
                {{ savingSchedule ? 'Saving...' : 'Save' }}
            </button>
            <button type="button" class="btn bg-danger text-white btn-sm" :disabled="savingSchedule" @click="closeScheduleModal">
                Close
            </button>
        </div>
    </modal>
    <loan-account-transfer ref="loanTransfer" @updated="refresh" />
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import EmployeeForm from './EmployeeForm.vue'
import LoanAccountTransfer from './LoanAccountTransfer.vue'
import DisplayFirstAddress from '../../components/address/DisplayFirstAddress.vue';
import DisplayMobiles from '../../components/mobile/DisplayMobiles.vue';
import Paginate from "vuejs-paginate";
import Constants from '../../components/utilities/Constants.vue';
import LoanAccountFollowed from '../loanFollowed/LoanAccountFollowed.vue';
export default {
    components:{EmployeeForm,DisplayFirstAddress,DisplayMobiles,Paginate,LoanAccountFollowed,LoanAccountTransfer},
    mixins:[Constants],
    props:['id'],
    data(){
        return {
            activecount:0,
            cashCollectorSavingIds:[],
            totalemp:0,
            currentpage:1,
            totalpage:0,
            noofrec:10,
            followedloan:[],
            followedid:'',
            scheduleEmployee:null,
            scheduleDurationFrom:null,
            scheduleDurationTo:null,
            savingSchedule:false
        }
    },
    computed:{
		...mapGetters([
		    'viewno','employees','loggedinuser','employeescount','edititem'
		]),
         noofpages(){
                return Math.ceil(parseInt(this.employeescount) / parseInt(this.noofrec))
            }
	},
    watch: {
        '$route.params.id'() {
            this.refresh()
        }
    },
    mounted(){
        this.refresh();
        console.log("props id"+this.$route.params.id)
	},
    methods:{
        async saveCashCollector(employee, event) {
            if (this.cashCollectorSavingIds.includes(employee.id)) return
            const previous = Number(employee.can_collect_cash) === 1
            const enabled = event.target.checked
            this.cashCollectorSavingIds.push(employee.id)
            try {
                const response = await this.$http.post('api/employees/cash-collectors/save', { employee_id: employee.id, can_collect_cash: enabled })
                this.$set(employee, 'can_collect_cash', response.data.can_collect_cash)
                this.$notify({ text: 'Cash collection setting saved.', type: 'success' })
            } catch (error) {
                event.target.checked = previous
                this.$notify({ text: error.response?.data?.message || 'Unable to save cash collection setting.', type: 'error' })
            } finally { this.cashCollectorSavingIds = this.cashCollectorSavingIds.filter(id => id !== employee.id) }
        },
        clickCallback (currentpage) {
            this.currentpage=currentpage
            this.$store.commit("assigncurrentpage",currentpage);
            this.refresh()
        },
        active(item){
            if(item.active==1){
                this.$store.commit('assignloadingstatus',1)
                 let parm = {column:'active',id:item.id,value:0};
                this.$http.post('api/user/updatefield',parm)
                .then((response) => {
                    this.$store.commit('updateappendemployees',response.data);
                    this.refresh();
                    this.$store.commit('assignloadingstatus',0)
                })
                .catch((err) => {
                    console.log(err)
                });
            }else{
                this.$store.commit('assignloadingstatus',1)
                let parm = {column:'active',id:item.id,value:1};
                this.$http.post('api/user/updatefield',parm)
                .then((response) => {
                    this.$store.commit('updateappendemployees',response.data);
                    this.$store.commit('assignloadingstatus',0)
                    this.refresh();
                })
                .catch((err) => {
                    console.log(err)
                });
            }
        },
        edit(item){
            this.$store.commit('assignedititem',item)
            this.$store.commit('assignviewno',2)
        },
        openScheduleModal(item){
            this.scheduleEmployee = item
            this.scheduleDurationFrom = item.schedule_duration_from ?? item.schedule_duration ?? null
            this.scheduleDurationTo = item.schedule_duration_to ?? item.schedule_duration_from ?? item.schedule_duration ?? null
            this.$modal.show('schedule-modal')
        },
        closeScheduleModal(){
            this.$modal.hide('schedule-modal')
            this.scheduleEmployee = null
            this.scheduleDurationFrom = null
            this.scheduleDurationTo = null
        },
        saveSchedule(){
            const fromDays = Number(this.scheduleDurationFrom)
            const toDays = Number(this.scheduleDurationTo)
            if(!this.scheduleEmployee || !Number.isInteger(fromDays) || !Number.isInteger(toDays) || fromDays < 0 || toDays < 0 || toDays < fromDays){
                this.$notify({text:'Please enter valid from/to days',type:'error'})
                return
            }

            this.savingSchedule = true
            const param = {
                user_id:this.scheduleEmployee.id,
                schedule_duration_from:fromDays,
                schedule_duration_to:toDays
            }
            window.axios.post('api/user/schedule/duration/save',param)
                .then(response => {
                    this.scheduleEmployee.schedule_duration_from = response.data.data.schedule_duration_from
                    this.scheduleEmployee.schedule_duration_to = response.data.data.schedule_duration_to
                    this.$notify({text:response.data.message,type:'success'})
                    this.closeScheduleModal()
                })
                .catch(error => {
                    const message = error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : 'Unable to save schedule'
                    this.$notify({text:message,type:'error'})
                })
                .finally(() => {
                    this.savingSchedule = false
                })
        },
        
        refresh(){
            let param={active:this.$route.params.id,isemployee:1,noofrec:this.noofrec,currentpage:this.currentpage}
            window.axios.post('api/users/fetch',param)
	    		.then(response=>this.processResponse(response.data))
	    		.catch(error=>console.log(error));
            window.axios.post('api/users/fetch/count',param)
	    		.then(response=>this.processempCountResponse(response.data))
	    		.catch(error=>console.log(error));
            window.axios.post('api/followed/userid/all')
	    		.then(response=>this.processempFollowedResponse(response.data))
	    		.catch(error=>console.log(error));
        },
        processResponse(data){
            this.$store.commit('assignemployees',data)
        },
        processempCountResponse(data){
            this.$store.commit('assignemployeescount',data)
        },
        processempFollowedResponse(data){
            this.followedloan=data
        },
        getfollow(item){
            if(this.followedloan!=null && this.followedloan.length>0 ){
                let found = this.followedloan.find((block)=>block.followedbyid==item.id)
                if(typeof found != 'undefined'){
                    return found.count
                }
            }
            return 0
        },
        getfollowedaccounts(item){
            if(this.loginusercheck(131)){
                this.followedid=item.id
                this.$store.commit('assignviewno',3)
            }else{
                alert("No rights to access")
            }
            
        },
        back(){
            this.$store.commit('assignviewno',1)
        },
        
    }
}
</script>

<style scoped>
.btn-primary:hover{
    text-decoration: none !important;
    background-color: #3a476b !important;
}
</style>
